<div class="order-return-table__wrapper">
  <table class="lum-table lum-table--classic striped">
    <tr class="table__head-row">
      <th>Return Order ID</th>
      <th>Order Date</th>
      <th>Created Date</th>
      <th>Order Status</th>
      <th>Payment Method</th>
      <th>Source</th>
      <th>Refund Item Qty</th>
      <th>Grand Total Refund</th>
      <th></th>
    </tr>
    <tbody>
      <tr
        *ngFor="let orderReturn of orderReturns; trackBy: trackById; let i = index"
      >
        <td>{{ orderReturn.id }}</td>
        <td>{{ orderReturn.orderDate | date: 'mediumDate' }}</td>
        <td>{{ orderReturn.createDate | date: 'mediumDate' }}</td>
        <td>
          <mat-chip
            *ngIf="orderReturn.orderStatus; else noData"
            class="
              lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
            "
            >{{ orderReturn.orderStatus }}</mat-chip
          >
        </td>
        <td>
          <mat-chip
            *ngIf="orderReturn.paymentMethod; else noData"
            class="
              lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
            "
            >{{ orderReturn.paymentMethod }}</mat-chip
          >
        </td>
        <td>
          <mat-chip
            *ngIf="orderReturn.source; else noData"
            class="
              lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
            "
            >{{ orderReturn.source }}</mat-chip
          >
        </td>
        <td>{{ orderReturn.totalOrderQuantity }}</td>
        <td>{{ orderReturn.amountPaid | currency }}</td>
        <td>
          <div class="btn-group">
            <button
              type="button"
              class="lum-button lum-button--tertiary lum-button--small"
              mat-button
              [routerLink]="[
                '/orders/return-orders/',
                parentSalesOrderId,
                'view',
                orderReturn.id,
              ]"
            >
              View
              <lum-ui-icon
                class="ml-2"
                icon="edit-view"
                [width]="24"
                [height]="24"
                color="#5563d6"
              ></lum-ui-icon>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <ng-template #noData>
    <strong>N/A</strong>
  </ng-template>
</div>
